import { render, staticRenderFns } from "./OrderUniconta.vue?vue&type=template&id=5dede310"
import script from "./OrderUniconta.vue?vue&type=script&lang=js"
export * from "./OrderUniconta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports